import { useMutation } from '@tanstack/react-query';
import { HStack } from '@cad-arc';
import { useApiClient } from '@m43/core';
import { FormButton } from '../../forms/integrated-form-components/form-button';
import { useWorkspacePanel } from '../../panels/hooks/use-workspace-panel';
import { useEventMetadataStore } from '../event-panel-form/event-metadata';
import { useRefreshEventPanel } from '../refresh-event-panel';
import { observer } from 'mobx-react-lite';
import { EventWithDirtyFieldsFooter } from './event-with-dirty-fields-footer';
import { countDirtyFields } from '../count-dirty-fields';
import { useIntegratedForm } from '../../forms/use-integrated-form';
import { EventPanelFormType } from '@mark43/cad-api';
import { useFormState } from 'react-hook-form';
import { ClearEventButton } from './clear-event-button';
import { EventPanelResource } from '@mark43/cad-api';

const ScheduledEventBaseFooter = observer(function ScheduledBaseEventFooter() {
    const eventId = useWorkspacePanel().linkedEntityId;
    const eventMetadataStore = useEventMetadataStore();
    const apiClient = useApiClient();
    const refreshEventPanel = useRefreshEventPanel();
    const executeScheduledEventMutation = useMutation((args: { scheduledEventId: number }) => {
        return apiClient.request<EventPanelResource.ExecuteScheduledEvent>({
            method: 'POST',
            url: 'event_panel/scheduled_event/execute/',
            data: {
                scheduledEventId: args.scheduledEventId,
            },
        });
    });
    if (!eventId) {
        return null;
    }
    return (
        <HStack w="100%" justifyContent="flex-end">
            <ClearEventButton />
            <FormButton
                isLoading={executeScheduledEventMutation.isLoading}
                isDisabled={!!eventMetadataStore.state.metadata?.scheduledEventScheduledEndDateUtc}
                variant="solid"
                onClick={() => {
                    executeScheduledEventMutation
                        .mutateAsync({ scheduledEventId: eventId })
                        .then((response) => {
                            const eventPanelView = response.data.data;
                            if (eventPanelView) {
                                refreshEventPanel({ eventPanelView });
                            }
                        });
                }}
            >
                Activate
            </FormButton>
        </HStack>
    );
});

export function ScheduledEventFooter() {
    const eventForm = useIntegratedForm<EventPanelFormType>();
    const { dirtyFields } = useFormState({
        control: eventForm.form.control,
    });
    const dirtyFieldCount = countDirtyFields(dirtyFields);
    return dirtyFieldCount > 0 ? (
        <EventWithDirtyFieldsFooter dirtyFieldCount={dirtyFieldCount} />
    ) : (
        <ScheduledEventBaseFooter />
    );
}
